<template>
    <v-dialog v-model="dialog" :width="width" v-bind="$attrs" v-on="$listeners">
        <template #activator="{ on }">
            <slot name="button" :dialog="dialog" :on="on"></slot>
        </template>
        <v-card>
            <v-card-title class="headline" primary-title>{{ title }}</v-card-title>
            <v-card-text v-html="text"></v-card-text>
            <slot name="additional-content"></slot>
            <v-card-actions>
                <v-spacer v-if="hideTrueBtn"></v-spacer>
                <v-btn rounded color="primary" text @click="triggerFalse">{{
                    hideTrueBtn ? t('default::confirmation.close') : falseBtnText
                }}</v-btn>
                <v-spacer v-if="!hideTrueBtn"></v-spacer>
                <v-btn v-if="!hideTrueBtn" rounded color="primary" @click="triggerTrue">{{ trueBtnText }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        width: {
            type: Number,
            required: false,
            default: 400,
        },
        title: {
            type: String,
            required: false,
            default: () => {
                return t('default::confirmation.question');
            },
        },
        text: {
            type: String,
            required: false,
            default: '',
        },
        trueBtnText: {
            type: String,
            required: false,
            default: () => {
                return t('default::confirmation.yes');
            },
        },
        falseBtnText: {
            type: String,
            required: false,
            default: () => {
                return t('default::confirmation.no');
            },
        },
        hideTrueBtn: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
        };
    },
    methods: {
        triggerTrue() {
            this.dialog = false;
            this.$emit('true');
        },
        triggerFalse() {
            this.dialog = false;
            this.$emit('false');
        },
    },
};
</script>
